import { render, staticRenderFns } from "./EditClaim.vue?vue&type=template&id=4019cbcf"
import script from "./EditClaim.vue?vue&type=script&lang=js"
export * from "./EditClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports